import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { InputErrorComponent } from '../input-error/input-error.component';

@Component({
  selector: 'merz-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
})
export class InputComponent extends InputErrorComponent {

  @Input() label = '';
	@Input() description = '';
	@Input() type = 'text';
	@Input() hint = '';
	@Input() placeholder = '';
	@Input() format = '';
	@Input() autofocus = false;
	@Input() tabindex;
	@Input('margin-right') marginRight = 15;
	@Input('no-floated-label') nofloatedLabel = true;

	@Output() enter = new EventEmitter<boolean>();
  @ViewChild('inputField') inputField: ElementRef;

  focus = false;

	ngOnInit() {}

	onFocus(event) {
		this.focus = event.returnValue;
	}

	ngAfterViewInit() {
		if (this.autofocus) {
			setTimeout(() => this.inputField?.nativeElement?.focus(), 200);
		}
	}
}
